import { render, staticRenderFns } from "./veStuStipendMy.vue?vue&type=template&id=46ad7431&scoped=true"
import script from "./veStuStipendMy.vue?vue&type=script&lang=js"
export * from "./veStuStipendMy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ad7431",
  null
  
)

export default component.exports